import { render } from "./InitializePage.vue?vue&type=template&id=46c0d114"
import script from "./InitializePage.vue?vue&type=script&lang=js"
export * from "./InitializePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__